<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-sheet rounded class="px-6 py-6" v-if="subscription">
          <div class="body-1 font-weight-bold mb-2">Platební plán</div>
          <div class="text-h4 mb-2">{{ subscription.product.name }}</div>
          <div>
            <span v-if="subscription.isTrial && !subscription.isCanceled"
              >Zkušební verze do:
            </span>
            <span v-else-if="!subscription.isTrial && !subscription.isCanceled">
              Příští platba proběhne:
            </span>
            <span v-else-if="subscription.isCanceled">
              Členství bude ukončeno:
            </span>
            <ui-datetime date :value="subscription.validUntil" />
          </div>
          <v-btn
            small
            text
            rounded
            class="mt-2"
            v-if="!subscription.isCanceled"
            @click="onCancelSubscription"
          >
            <v-icon left>mdi-close</v-icon>
            Zrušit členství
          </v-btn>
        </v-sheet>
      </v-col>
      <!--      <v-col cols="12">
        <v-sheet rounded class="px-6 py-6">
          <div class="body-1 font-weight-bold mb-2">Faktury</div>
          <v-btn small text rounded class="mx-n3">
            Přejít na faktury
          </v-btn>
        </v-sheet>
      </v-col>-->
    </v-row>
  </div>
</template>

<script>
import { get, call } from "vuex-pathify"

export default {
  computed: {
    ...get("auth", ["subscription"]),
  },
  methods: {
    ...call("auth", ["cancelSubscription"]),
    onCancelSubscription() {
      this.cancelSubscription()
    },
  },
}
</script>
